import { Info } from '@ksb/ui';
import { useSeitenStile } from '../components/stile';

/** Hinweis für angemeldete Mitarbeiter, die nicht auf der Teilnehmerliste stehen (F-06). Keine Daten. */
export function KeinTeilnehmerSeite({ ansprechpartner }: { ansprechpartner?: string | undefined }) {
  const s = useSeitenStile();
  return (
    <section className={`ksb-card ${s.kopf}`}>
      <Info size={32} aria-hidden="true" />
      <h1 className="ksb-h1">Keine Schulungen für Sie vorgesehen</h1>
      <p style={{ margin: 0 }}>
        Sie stehen nicht auf der Teilnehmerliste der Schulungskampagne SmartWork. Deshalb können Sie
        hier keine Termine buchen.
      </p>
      {ansprechpartner && <p style={{ margin: 0 }}>{ansprechpartner}</p>}
    </section>
  );
}
